/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneHeading from 'sites/allas/components/standalone/Heading';

export const DynamicStandaloneHeading = StandaloneHeading;
export type DynamicStandaloneHeadingProps = PropsFromComponent<typeof StandaloneHeading>;

export const DynamicStandaloneHeadingWith = (extras: DynamicStandaloneExtras): typeof StandaloneHeading => {
    return function DynamicStandaloneHeading(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Heading');
        return <StandaloneHeading {...mergeProps({ options: { theme } }, props)} />;
    }
}